<template>
  <page-layout-full v-if="item" class="category-item" :breadcrumb="breadcrumb">
    <template #title>
      <base-icon
        class="category-item__icon"
        :name="item.url"
        width="32"
        height="32"
      />
      {{ item.title }}
    </template>

    <category :category="item" class="category-list__item" />
  </page-layout-full>
</template>

<script>
import PageLayoutFull from "@/components/page/PageLayoutFull.vue";
import BaseIcon from "@/components/shared/BaseIcon.vue";
import Category from "../components/category/Category.vue";
// utils
import { mapGetters } from "vuex";

export default {
  components: {
    PageLayoutFull,
    BaseIcon,
    Category,
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: this.metaList,
    };
  },
  computed: {
    ...mapGetters("catalog", {
      getCategory: "getCategory",
    }),
    ...mapGetters({
      cityNameIn: "settings/cityNameIn",
    }),
    item() {
      return this.getCategory(this.$route.params.category);
    },
    // Без города и описания страницы разделов у всех городов совпадали дословно
    // и попадали в поиск как дубли
    metaTitle() {
      // Заглушка попадала в выдачу: робот снимает заголовок до ответа API
      if (!this.item) return undefined;

      return this.cityNameIn
        ? `${this.item.title} — купить ${this.cityNameIn}`
        : this.item.title;
    },
    metaList() {
      if (!this.item) return [];

      const where = this.cityNameIn ? ` ${this.cityNameIn}` : "";
      return [
        {
          vmid: "description",
          name: "description",
          content:
            `${this.item.title}${where} — подбор по марке автомобиля, ` +
            `цены и наличие, доставка и самовывоз. Интернет-магазин АвтоВеликан.`,
        },
      ];
    },
    breadcrumb() {
      return [
        {
          title: "Все каталоги",
          to: {
            name: "category-list",
          },
        },
        { title: this.item.title },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.category-item {
  &__icon {
    margin-right: 0.5rem;
  }
}
</style>
